import { styled } from 'next-yak';
import { SocialProps } from './types';

export const IconLink = styled.a<Omit<SocialProps, 'link' | 'type'>>`
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--text_light);;
  border-radius: 50%;
  padding: 0.4rem;

  height: 4rem;
  width: 4rem;

  transition: fill 0.6s ease 0s;

  svg {
    height: 2rem;
    width: 2rem;

    path {
      fill: ${({ color }) => color && `var(${color})`};
      transition: fill 0.6s ease 0s;
    }
  }

  &:hover {
      background-color: var(--secondary_400);
      border-color: var(--secondary_400);
      svg {
        path {
        fill: var(--text_dark);
      }
    }
  }
`;
